
import './App.css';
import React from 'react';
import SearchBar from '../searchBar/searchBar';
import SearchResults from '../searchResults/searchResults';
import PlayList from '../Playlist/playList';
import Spotify from '../../util/Spotify';

import { library } from '@fortawesome/fontawesome-svg-core';
import { fab }  from '@fortawesome/free-brands-svg-icons';
import { faPlay, faPause } from "@fortawesome/free-solid-svg-icons";

library.add(fab, faPlay, faPause);

class App extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      searchResults: [],
      playlistName: 'Cool playlist',
      playlistTracks: []
  }

  this.addTrack = this.addTrack.bind(this);
  this.removeTrack = this.removeTrack.bind(this);
  this.updatePlaylistName = this.updatePlaylistName.bind(this);
  this.savePlaylist = this.savePlaylist.bind(this);
  this.search = this.search.bind(this);
};

    addTrack(track) {
      let tracks = this.state.playlistTracks;
      if(tracks.find(savedTrack => savedTrack.id === track.id)) {
        return;
      } 
        tracks.push(track);
        this.setState({playlistTracks: tracks})
      }

    removeTrack(track) {
      let tracks = this.state.playlistTracks;
      tracks = tracks.filter(currentTrack => currentTrack.id !== track.id);

      this.setState({ playlistTracks: tracks })
    }


    
    updatePlaylistName(name) {
      this.setState({ playlistName: name});
    }


    savePlaylist() {
      const trackUris = this.state.playlistTracks.map(track => track.uri);
      Spotify.savePlaylist(this.state.playlistName, trackUris).then(() => {
        this.setState({
          playlistName: 'New Playlist',
          playlistTracks: []
        })
      })
      alert('Playlist successfully saved to your Spotify account')
    }

    search(term) {
       Spotify.search(term).then(searchResults => {
         this.setState({searchResults: searchResults})
       })
    }

    componentDidMount() {
      window.addEventListener('load', Spotify.search(''));
    }


  render() {
  return (
    <div>
      <h1>Playlist<span className="highlight">Jam</span>z</h1>
      <div className="App">
        <SearchBar 
          onSearch={this.search}
        /> 

        <div className="App-playlist">
          <SearchResults 
            onAdd={this.addTrack} 
            searchResults={this.state.searchResults} 
          />

          <PlayList 
            playlistName={this.state.playlistName} 
            playlistTracks={this.state.playlistTracks} 
            onRemove={this.removeTrack}
            onNameChange={this.updatePlaylistName}
            onSave={this.savePlaylist}

          />

        </div>
      </div>
    </div>
      );
};
}

export default App;
